import { useState } from "react";
import { toast } from "sonner";
import { http, errMsg, formatDate } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { F, inputCls } from "@/components/admin/shared";

export const AccountPanel = ({ user }) => {
  const { logout } = useAuth();
  const logoutAll = async () => {
    try { await http.post("/auth/logout-all"); } catch (e) { toast.error(errMsg(e)); return; }
    await logout();
  };
  const [f, setF] = useState({ current_password: "", new_password: "" });
  const save = async (e) => {
    e.preventDefault();
    try {
      await http.post("/auth/change-password", f);
      toast.success("Kata sandi diperbarui");
      setF({ current_password: "", new_password: "" });
    } catch (err) { toast.error(errMsg(err)); }
  };
  return (
    <div className="grid md:grid-cols-2 gap-4" data-testid="account-panel">
      <form onSubmit={save} className="rounded-2xl bg-white border border-nanina-line p-5 space-y-3">
        <h3 className="text-sm font-bold text-nanina-green">Ganti kata sandi</h3>
        <p className="text-xs text-nanina-muted">Login sebagai {user?.email}</p>
        <F label="Kata sandi saat ini"><input type="password" required className={inputCls} value={f.current_password} onChange={(e) => setF({ ...f, current_password: e.target.value })} data-testid="account-current-password" /></F>
        <F label="Kata sandi baru (min. 8 karakter)"><input type="password" required minLength={8} className={inputCls} value={f.new_password} onChange={(e) => setF({ ...f, new_password: e.target.value })} data-testid="account-new-password" /></F>
        <button className="rounded-full bg-nanina-green text-white text-sm font-semibold px-5 py-2.5" data-testid="account-save-button">Simpan</button>
      </form>
      <div className="rounded-2xl bg-[#EEF7E9] p-5 text-xs text-nanina-green space-y-2">
        <h3 className="text-sm font-bold">Keamanan Akun</h3>
        {user?.previous_login_at && <p data-testid="account-previous-login">Login sebelumnya: {formatDate(user.previous_login_at)}</p>}
        <p>Semua perubahan konten hanya dapat dilakukan setelah login admin. Sesi otomatis berakhir dan login dikunci 15 menit setelah 5 kali gagal.</p>
        <p>Formulir WhatsApp publik tidak menyimpan data pengunjung di server.</p>
        <p>Foto draft dan foto tanpa izin publikasi tidak dapat diakses publik.</p>
        <p>Mengganti kata sandi otomatis mengeluarkan sesi di perangkat lain.</p>
        <button onClick={logoutAll} className="rounded-full border border-red-300 text-red-700 text-xs font-semibold px-4 py-2 bg-white" data-testid="account-logout-all-button">Keluar dari semua perangkat</button>
      </div>
    </div>
  );
};
